<template>
  <div>
    <Breadcrumbs :items="itemsBreadcrumbs" class="ml-n6"/>
    <Heading :title="suggestionTitle" header headerColor="gray scale200">
      <template #subtitle>
        <span v-html="headerSubTitle" class="text-paragraph-2"/>
      </template>
    </Heading>
    <Row class="d-flex">
      <Col cols="12" md="6" lg="6" v-for="plugin in plugins" :key="plugin.id">
        <Card padding-less>
          <div class="d-flex align-center">
            <div class="pl-6 pt-6">
              <span class="text-h4 mt-1 mr-1 primary--text">{{ plugin.name }}</span>
            </div>
          </div>
          <div v-size.height="126" class="d-flex align-center">
            <div class="pl-6 pr-6 pb-6 pa-4">
              <span class="d-block text-paragraph-2 pr-2 pb-2 text-xs-h2">{{ plugin.desc }}</span>
            </div>
          </div>
          <template #actions>
            <div class="pl-6 pb-6">
              <Button
                  label="Ver plugin no Wordpress"
                  color="primary"
                  target="blank"
                  @click="seePlugin(plugin.slug)"
                />
              </div>
          </template>
        </Card>
      </Col>
    </Row>
  </div>
</template>

<style>

</style>

<script>
import { Row, Col, Heading, useLocale, Breadcrumbs, Card, Button } from '@locaweb/design-system-vue'
import pluginsData from '@/views/site/list/components/data/plugins.json'

export default {
  name: 'SiteDomain',
  components: {
    Row,
    Col,
    Heading,
    Breadcrumbs,
    Card,
    Button
  },
  props: {
    id: String
  },
  data () {
    return {
      plan: '',
      plugins: []
    }
  },
  created () {
    const text = this.itemsBreadcrumbs[1].text
    const word = text.split(' ')
    const wordDesire = word[word.length - 1].toLowerCase()
    this.plan = wordDesire
    this.plugins = pluginsData[this.plan]
  },
  setup () {
    const t$ = useLocale('sites.plugins')
    return {
      t$
    }
  },
  methods: {
    seePlugin (slug) {
      const protocol = 'https'
      const dominio = this.t$.domain.replaceValues(this.dataSite)
      console.log(dominio)
      const pluginName = slug.split(' ').join('-').toLowerCase()
      const url = `${protocol}://${dominio}/wp-admin/plugin-install.php?tab=plugin-information&plugin=${pluginName}`
      window.open(url, '_blank')
    }
  },
  computed: {
    dataSite () {
      const sites = JSON.parse(localStorage.getItem('dataSites'))
      const data = sites.filter(item => parseInt(this.id) === item.id)
      return data[0]
    },
    headerSubTitle () {
      const str = this.plan
      const strCapitalize = str.charAt(0).toUpperCase() + str.slice(1)
      const subTitle = this.t$.description1 + '<b>' + strCapitalize + '</b>' + this.t$.description2 + '<b>' + this.t$.domain.replaceValues(this.dataSite) + '</b>'
      return subTitle
    },
    suggestionTitle () {
      const str = this.plan
      const strCapitalize = str.charAt(0).toUpperCase() + str.slice(1)
      const title = 'Sugestão de Plugins ' + strCapitalize
      return title
    },
    itemsBreadcrumbs () {
      const title = JSON.parse(localStorage.getItem('headerProps'))
      const sites = JSON.parse(localStorage.getItem('dataSites'))
      const data = sites.filter(item => parseInt(this.id) === item.id)

      const items = [
        { text: 'Inicio', to: '/', disabled: false, exact: true },
        { text: title, to: `/${data[0].plan_id}`, disabled: false, exact: true },
        { text: 'Sugestão de Plugin', to: '/', disabled: true, exact: true }
      ]
      return items
    }
  }
}
</script>
